import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalMobileLayout, Modal, Text, Box, Button } from '@wix/design-system';
import { TooltipProps } from '.';

export const MobileTooltip: React.FC<TooltipProps> = ({
  children,
  isOpen,
  onCancel,
  content,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {children}
      <Modal screen="mobile" isOpen={(!disabled && isOpen) || false}>
        <ModalMobileLayout
          onCloseButtonClick={onCancel}
          footer={
            <Box align="right">
              <Button priority="primary" onClick={onCancel}>
                {t(
                  'charge-locator.charge-locator-form.invoice-number-tooltip.cta',
                )}
              </Button>
            </Box>
          }
          content={
            <Box width="calc(100% - 24px)">
              <Text>{content}</Text>
            </Box>
          }
        />
      </Modal>
    </>
  );
};
